import { useCallback, useState } from 'react';
import { ILoginOpcoesData, useAuth } from './auth';

type CredenciaisLoginOpcoes = {
  email: string;
  password: string;
};

export function useLoginOpcoes() {
  const { obterOpcoesLogin } = useAuth();
  const [isBuscandoOpcoes, setIsBuscandoOpcoes] = useState(false);

  const buscarOpcoesLogin = useCallback(
    async ({
      email,
      password,
    }: CredenciaisLoginOpcoes): Promise<ILoginOpcoesData> => {
      setIsBuscandoOpcoes(true);
      try {
        return await obterOpcoesLogin({ email, password });
      } finally {
        setIsBuscandoOpcoes(false);
      }
    },
    [obterOpcoesLogin],
  );

  return {
    buscarOpcoesLogin,
    isBuscandoOpcoes,
  };
}
